import { render } from "./codigoQr.vue?vue&type=template&id=2000a8e8&scoped=true"
import script from "./codigoQr.vue?vue&type=script&lang=js"
export * from "./codigoQr.vue?vue&type=script&lang=js"

import "./codigoQr.vue?vue&type=style&index=0&id=2000a8e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adripa\\Desktop\\acsa-generador-qr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2000a8e8"]])

export default __exports__